import type { ComponentProps } from "react"
import { type InputVariantProps, inputVariants } from "../../styles"
import { classNames } from "../../utils"

export type TextAreaProps = ComponentProps<"textarea"> & InputVariantProps

/**
 * Displays a form textarea.
 */
export function TextArea({
  className,
  disabled,
  error,
  variant,
  ...props
}: TextAreaProps) {
  return (
    <textarea
      className={classNames(
        inputVariants({ variant, disabled, error }),
        "h-auto w-full resize-y rounded-lg p-3",
        "bg-transparent outline-hidden",
        className,
      )}
      {...props}
    />
  )
}
